import React, { useEffect, useState } from 'react';
import api, { unwrap } from '../utils/api';
import { withCheck } from '../components/Icon';

export default function BrandingLogo() {
  const [imageUrl, setImageUrl] = useState('');
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState('');

  useEffect(() => {
    api.get('/miscellaneous/branding').then(r => {
      const v = unwrap(r);
      if (v?.imageUrl) setImageUrl(v.imageUrl);
    }).catch(() => {});
  }, []);

  async function uploadLogo(file) {
    if (!file) return;
    setBusy(true);
    setMsg('');
    try {
      const fd = new FormData();
      fd.append('file', file);
      const r = await api.post('/files/UploadBrandingLogo', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      const { url } = unwrap(r);
      setImageUrl(url);
      await api.post('/miscellaneous/branding', { imageUrl: url });
      setMsg('✓ Logo saved. It will appear on every template — pick a color per template in the field editor.');
    } catch (e) {
      setMsg('Upload failed: ' + (e?.response?.data?.body || e.message));
    } finally { setBusy(false); }
  }

  async function clearLogo() {
    setBusy(true);
    setMsg('');
    try {
      await api.post('/miscellaneous/branding', { imageUrl: '' });
      setImageUrl('');
      setMsg('Logo removed.');
    } catch (e) {
      setMsg('Failed: ' + (e?.response?.data?.body || e.message));
    } finally { setBusy(false); }
  }

  return (
    <>
      <h1>Branding Logo</h1>
      <p style={{ color: '#666', marginTop: 0, maxWidth: 640 }}>
        Upload your company logo (PNG with transparency works best). It will be placed on every template — small, on the left, vertical. The tint color is chosen per template in the field editor.
      </p>

      <div className="card" style={{ maxWidth: 520 }}>
        <div className="prop">
          <label>Logo image</label>
          <input type="file" accept="image/*" onChange={e => uploadLogo(e.target.files[0])} disabled={busy} />
        </div>

        {imageUrl && (
          <>
            <div style={{ marginTop: 12, padding: 16, background: '#f5f5f5', borderRadius: 6, textAlign: 'center' }}>
              <img src={imageUrl} alt="Branding logo" style={{ maxWidth: '100%', maxHeight: 200 }} />
            </div>
            <button className="btn secondary" onClick={clearLogo} disabled={busy} style={{ marginTop: 12 }}>
              Remove logo
            </button>
          </>
        )}

        {msg && <p style={{ marginTop: 12, color: msg.startsWith('✓') ? '#198754' : '#666' }}>{withCheck(msg)}</p>}
      </div>
    </>
  );
}
